import React from "react";
import SectionTitle from "../../../components/sectionTitle";
import { Box, Button, Dialog, DialogTitle, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";

function ConfirmationDialog({
  classes: { containerButton },
  onClose,
  onClickHandler,
  modal,
  modalKey = "confirm",
}) {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.confirm}
      maxWidth={"lg"}
      fullScreen={true}
    >
      <DialogTitle id="simple-dialog-title">
        <SectionTitle title={"Re-Initiate Confirmation"} />
      </DialogTitle>
      <Box m={1}>
        <Box p={1}>
          <Typography variant="caption">
            Do you really want to re-initiate the payment?
          </Typography>
          <Typography variant="caption">
           Before you proceed, please ensure that the amount has not already been debited from your account to avoid any duplicate charges.
          </Typography>
        </Box>

        <Box className={containerButton}>
          <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              type={"button"}
              variant={"contained"}
              color={"primary"}
              size={"small"}
              onClick={onClickHandler}
              fullWidth
            >
              Proceed
            </Button>
            <Box>&nbsp;</Box>
            <Button
              type={"button"}
              variant={"contained"}
              color={"secondary"}
              size={"small"}
              onClick={(event, reason) => onClose(event, reason, modalKey)}
              fullWidth
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(ConfirmationDialog);
